import React from "react";

export default function LoadingSpinner() {
  return (
    <div className="spinner-grow spinner-grow-sm text-info" role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
